/**
 * Debug logging utility
 * Only logs in development mode or when DEBUG flag is set
 */

const isDev = process.env.NODE_ENV === 'development';
const isDebug = process.env.NEXT_PUBLIC_DEBUG === 'true';

export const debug = {
    log: (...args: any[]) => {
        if (isDev || isDebug) {
            console.log(...args);
        }
    },
    warn: (...args: any[]) => {
        if (isDev || isDebug) {
            console.warn(...args);
        }
    },
    error: (...args: any[]) => {
        // Always log errors
        console.error(...args);
    },
    info: (...args: any[]) => {
        if (isDev || isDebug) {
            console.info(...args);
        }
    }
};
